<template>
  <div>
    <a-card :bordered="false" class="dashboard-bar-chart" style="width: 100%">
      <a-form
        id="components-form-demo-normal-login"
        class="login-form"
        style="width: 100%"
        :label-col="{ span: 3 }"
        :wrapper-col="{ span: 10 }"
      >
        <a-form-item class="mb-10" label="appId：" :colon="false">
          {{ appId }}
        </a-form-item>
        <a-form-item class="mb-5" label="secret：" :colon="false">
          <div style="display: flex; align-items: center">
            <div style="margin-right: 5px">
              {{ showSecret ? appSecret : "***********" }}
            </div>
            <a-icon
              class="icon_class"
              type="copy"
              @click="copyFun(appSecret)"
            />
            <a-icon
              class="icon_class"
              v-if="showSecret"
              @click="showSecret = false"
              type="eye-invisible"
            />
            <a-icon
              class="icon_class"
              @click="showSecret = true"
              v-else
              type="eye"
            />
          </div>
        </a-form-item>
        <a-form-item class="mb-5" label="通知地址：" :colon="false">
          <div style="display: flex; align-items: flex-start">
            <!-- <a-textarea
              v-model="notifyUrl"
              :maxLength="255"
              placeholder="请输入通知地址"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            /> -->
            <a-input
              v-model="notifyUrl"
              :maxLength="255"
              placeholder="请输入通知地址"
            />
            <a-button
              v-if="oldNotifyUrl"
              type="primary"
              style="margin-left: 10px"
              @click="testFun"
            >
              测试回调
            </a-button>
          </div>
        </a-form-item>
        <a-form-item>
          <a-row :gutter="24">
            <a-col
              :span="12"
              :push="14"
              class="mb-24"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 30px;
              "
            >
              <div>
                <a-button
                  type="primary"
                  block
                  style="width: 100px"
                  html-type="submit"
                  @click="handleSubmit"
                >
                  保存
                </a-button>
              </div>
            </a-col></a-row
          >
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script>
import { getAppIdSecret, updateNotifyUr, notifyCallback } from "@/api/user";

export default {
  props: {
    userInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      showSecret: false,
      appId: "",
      appSecret: "",
      oldNotifyUrl: "",
      notifyUrl: "",
    };
  },
  beforeCreate() {},
  created() {
    this.getAppIdSecret();
  },
  methods: {
    getAppIdSecret() {
      getAppIdSecret({ id: this.userInfo.id }).then((res) => {
        console.log(res);
        this.appId = res.appId;
        this.appSecret = res.appSecret;
        this.notifyUrl = res.notifyUrl;
        this.oldNotifyUrl = res.notifyUrl;
      });
    },
    copyFun(text) {
      const input = document.createElement("input");
      input.value = text;

      // 将输入框添加到页面，但不显示
      document.body.appendChild(input);
      input.select(); // 选择输入框的内容

      // 执行复制命令
      document.execCommand("copy");
      this.$message.success("复制成功");
      // 移除临时输入框
      document.body.removeChild(input);
    },

    // Handles input validation after submission.
    handleSubmit(e) {
      if (!this.notifyUrl) {
        this.$message.warning("请输入通知地址");
        return;
      }

      updateNotifyUr({
        id: this.userInfo.id,
        notifyUrl: this.notifyUrl,
      })
        .then((res) => {
          console.log(res);
          this.$message.success("保存成功");
          this.getAppIdSecret();
        })
        .catch((err) => {});
    },
    testFun() {
      notifyCallback({ id: this.userInfo.id }).then((res) => {
        console.log(res);
      });
    },

    validatePassword(password) {
      const regex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{8,20}$/;
      return regex.test(password);
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  background-color: #ffffff;
}
.code_class {
  display: flex;
}
.login_title_box {
  font-size: 30px;
  font-weight: bold;
}
.login_out_box {
  display: flex;
  align-items: center;
  justify-content: center;
  .login_out_btn {
    color: #0091fb;
    cursor: pointer;
  }
}
.item {
  display: flex;
  align-items: center;
  .point {
    width: 8px;
    height: 8px;
    background-color: #727272;
    margin-right: 5px;
    border-radius: 50%;
  }
}
.icon_class {
  font-size: 20px;
  margin: 0 5px;
  cursor: pointer;
}
</style>
